import { render, staticRenderFns } from "./VerticalStepper.vue?vue&type=template&id=15f65dae"
import script from "./VerticalStepper.vue?vue&type=script&lang=js"
export * from "./VerticalStepper.vue?vue&type=script&lang=js"
import style0 from "./VerticalStepper.vue?vue&type=style&index=0&id=15f65dae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports